<template>
  <div>
    <LDBsTable
      url="arena/users"
      defaultSort="id"
      defaultOrder="asc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
    >
      <div class="form-group col-lg-4">
        <label for="id">{{ $t("id") }}</label>
        <input
          type="text"
          id="id"
          name="id"
          class="form-control"
          :placeholder="$t('ph_id')"
          v-model="query.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="name">{{ $t("name") }}</label>
        <input
          type="text"
          id="name"
          name="name"
          class="form-control"
          :placeholder="$t('type_name')"
          v-model="query.USR_NOM"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="Login">{{ $t("Login") }}</label>
        <input
          type="text"
          id="Login"
          name="Login"
          class="form-control"
          placeholder="Informe o login"
          v-model="query.USR_LGN"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="email">{{ $t("email") }}</label>
        <input
          type="text"
          id="email"
          name="email"
          class="form-control"
          :placeholder="$t('type_email')"
          v-model="query.USR_EML"
        />
      </div>

      <div class="form-group col-lg-8">
        <label for="usertype">{{ $t("usertype") }}</label>
        <Combobox
          class="bg-white"
          name="usertype"
          :placeholder="$t('select_a_item')"
          :options="userTypes"
          :initial-value="query.TUS_ID"
          label="TUS_DSC"
          v-model="query.TUS_ID"
          :reduce="(userType) => userType.id"
        />
      </div>

      <div class="form-group col-lg-12">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="clients"
          :initial-value="query.CLI_ID"
          label="CLI_DSC"
          v-model="query.CLI_ID"
          :reduce="(client) => client.CLI_ID"
        />
      </div>
    </LDBsTable>

    <!-- MODAL INACTIVE USER -->
    <div
      class="modal fade"
      id="modalInactiveUser"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalInactiveUserLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalInactiveUserLabel">
              Desativar usuário
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                NOME: <strong>{{ dataToUpdate.USR_NOM }}</strong>
              </li>
              <li>
                LOGIN: <strong>{{ dataToUpdate.USR_LGN }}</strong>
              </li>
              <li>
                CLIENTE: <strong>{{ dataToUpdate.clientName }}</strong>
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t("close") }}
            </button>

            <LoaderButton
              class="mt-3"
              @click="disableUser"
              :loading="isLoading"
            >
              {{ $t("confirm") }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";
import Combobox from "@/components/shared/ComboBox";
import LoaderButton from '@/components/button/LoaderButton'
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "ArenaUserList",

  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data() {
    return {
      columns: [
        {
          title: this.$t("id"),
          field: "id",
          sortable: true,
        },
        {
          title: this.$t("name"),
          field: "USR_NOM",
          sortable: true,
        },
        {
          title: this.$t("Login"),
          field: "USR_LGN",
          sortable: false,
        },
        {
          title: this.$t("email"),
          field: "USR_EML",
        },
        {
          title: this.$t("type"),
          field: "userTypeName",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          title: this.$t("client"),
          field: "clientName",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          title: this.$t("datetime_expiration"),
          field: "USR_DHE",
          formatter: (value) => {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
          },
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "100%",
          formatter: function (value, row) {
            let buttons = `
              <a
                title="Editar usuário"
                href="#/main/arena/user/${value}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>
            `;

            const today = moment();

            if (moment(row.USR_DHE).isAfter(today)) {
              buttons += `
                <button
                  title="Desativar usuário"
                  data-target="#modalInactiveUser"
                  data-id='${value}'
                  data-name='${row.USR_NOM}'
                  data-login='${row.USR_LGN}'
                  data-clientid='${row.CLI_ID}'
                  data-clientname='${row.clientName}'
                  data-email='${row.USR_EML}'
                  data-usertype='${row.TUS_ID}'
                  data-toggle="modal"
                  class="edit mb-1 btn btn-action btn-danger btn-circle light-bottom-shadow text-white"
                >
                  <i class="fas fa-user-times" />
                </button>
              `;
            }

            return buttons;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "arena_usuarios" },
      },
      queryToUse: {},
      query: {
        id: "",
        USR_NOM: "",
        USR_LGN: "",
        USR_EML: "",
        TUS_ID: undefined,
        CLI_ID: undefined,
      },
      dataToUpdate: {}
    };
  },

  computed: {
    ...mapState({
      lastquery: (state) => state.filtershistory.query,
      clients: (state) => state.arena.clients,
      userTypes: (state) => state.arena.userTypes,
      isLoading: (state) => state.arena.isLoading,
    }),
  },

  methods: {
    clear() {
      this.query.id = ""
      this.query.USR_NOM = ""
      this.query.USR_LGN = ""
      this.query.USR_EML = ""
      this.query.TUS_ID = null
      this.query.CLI_ID = null
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase();
    },

    async disableUser() {
      const { id, ...rest } = this.dataToUpdate

      await this.$store.dispatch(
        'arena/editUser',
        {
          id,
          data: {
            ...rest,
            CLI_ID: 310
          }
        }
      )

      $("#modalInactiveUser").modal("hide");
      $("#search").trigger("click");
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery["arenauser"]
      ? this.lastquery["arenauser"]
      : this.query;
  },

  async mounted() {
    await Promise.all([
      this.$store.dispatch("arena/fetchClients"),
      this.$store.dispatch("arena/fetchArenaUserTypes"),
    ]);

    if (this.lastquery["arenauser"]) {
      for (const [key, value] of Object.entries(this.lastquery["arenauser"])) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;

    const global = this;

    $("#modalInactiveUser").on("show.bs.modal", function (event) {
      const button = $(event.relatedTarget);

      global.dataToUpdate = {
        id: button.data("id"),
        USR_NOM: button.data("name"),
        USR_LGN: button.data("login"),
        CLI_ID: button.data("clientid"),
        clientName: button.data("clientname"),
        USR_EML: button.data("email"),
        TUS_ID: button.data("usertype"),
        USR_DHE: moment().subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")
      }
    });

    $("#modalInactiveUser").on("hide.bs.modal", function (event) {
      global.dataToUpdate = {}
    });
  },

  destroyed() {
    this.$store.dispatch("filtershistory/setQuery", {
      key: "arenauser",
      query: this.query,
    });
  },
};
</script>
